import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from './Main';
import Footer from './Footer';
import LoanEligibilityCalculator from './LoanEligibilityCalculator';
import ThankYouPage from './ThankYouPage'; 

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <>
            <Main />
            <LoanEligibilityCalculator />
            <Footer />
          </>
        } />
        <Route path="/thank-you" element={<ThankYouPage />} />
      </Routes>
    </Router>
  );
}

export default App;
